module.exports = __webpack_public_path__ + "img/7-1_08.111fba11.jpg";